// extracted by mini-css-extract-plugin
export default {"customerSearchIcon":"CustomersPage_customerSearchIcon__DeFms","customerSearchInput":"CustomersPage_customerSearchInput__qbho9","customerNotes":"CustomersPage_customerNotes__Q5As-"};